import { render, staticRenderFns } from "./SelfPage.vue?vue&type=template&id=02b493be&scoped=true&"
import script from "./SelfPage.vue?vue&type=script&lang=js&"
export * from "./SelfPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=02b493be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b493be",
  null
  
)

export default component.exports